var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONStruct, nullable, property } from 'badphraim/data/JSONStruct';
export class ewJSONDepartment extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.eier = 0;
    }
}
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONDepartment.prototype, "access", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONDepartment.prototype, "adresse", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONDepartment.prototype, "avdelingsleder", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONDepartment.prototype, "bank", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONDepartment.prototype, "eier", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONDepartment.prototype, "epost", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONDepartment.prototype, "id", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONDepartment.prototype, "kode", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONDepartment.prototype, "lat", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONDepartment.prototype, "logo", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONDepartment.prototype, "long", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], ewJSONDepartment.prototype, "minbedrift", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONDepartment.prototype, "minbedriftid", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONDepartment.prototype, "mobil", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONDepartment.prototype, "navn", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONDepartment.prototype, "orgnr", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONDepartment.prototype, "portal_redirect_url", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONDepartment.prototype, "portal_url", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONDepartment.prototype, "postnr", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONDepartment.prototype, "sted", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONDepartment.prototype, "telefon", void 0);
